const $win = $(window);
const $doc = $(document);
const winHeight = $win.height();

const animate = (scroll) => {
  $('.js-animation-fade-in').each(function() {
    const $this = $(this);

    if (scroll + winHeight * 0.95 > $this.offset().top) {
      const animationClass = 'animate__animated animate__fadeInUp';

      if ( !$this.hasClass('animated') ) {
        $this.addClass( 'animated' );
        $this.addClass( animationClass );
      }
    }
  });
};

$win.on('load scroll', function(event) {
  const scroll = $win.scrollTop();

  animate(scroll);
});

animate(scroll);
